import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  makeStyles,
  Box,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 16,
    paddingBottom: 8,
  },

  dialogTitle: {
    fontWeight: "bold",
    fontSize: 20,
    textAlign: "center",
    paddingBottom: 10,
  },

  campo: {
    marginBottom: theme.spacing(2),
  },

  botoes: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
  },

  botaoCancelar: {
    backgroundColor: "#e5e7eb",
    color: "#111",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 10,
    "&:hover": {
      backgroundColor: "#d1d5db",
    },
  },

  botaoSalvar: {
    backgroundColor: "#2563eb",
    color: "#fff",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 10,
    padding: theme.spacing(1, 3),
    boxShadow: "0 3px 8px rgba(37,99,235,0.3)",
    "&:hover": {
      backgroundColor: "#1e3a8a",
    },
  },
}));

export default function ContactModal({ aberto, onFechar, onSalvar, contato }) {
  const classes = useStyles();

  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");

  useEffect(() => {
    if (contato) {
      setNome(contato.nome || "");
      setTelefone(contato.telefone || "");
      setPhotoUrl(contato.photoUrl || "");
    } else {
      setNome("");
      setTelefone("");
      setPhotoUrl("");
    }
  }, [contato]);

  const salvar = () => {
    if (!telefone) return alert("Telefone é obrigatório!");

    const payload = {
      id: contato?.id,
      nome: nome || null,
      telefone,
      photoUrl: photoUrl || null,
    };

    onSalvar(payload);
    onFechar();
  };

  return (
    <Dialog
      open={aberto}
      onClose={onFechar}
      fullWidth
      maxWidth="sm"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle className={classes.dialogTitle}>
        {contato ? "✏️ Editar Contato" : "🆕 Novo Contato"}
      </DialogTitle>

      <DialogContent>
        <Box mt={1.5}>
          <TextField
            label="Nome"
            fullWidth
            variant="outlined"
            className={classes.campo}
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />

          <TextField
            label="Telefone"
            placeholder="55 + DDD"
            fullWidth
            variant="outlined"
            className={classes.campo}
            value={telefone}
            onChange={(e) => setTelefone(e.target.value)}
          />

          <TextField
            label="URL da Foto (opcional)"
            fullWidth
            variant="outlined"
            className={classes.campo}
            value={photoUrl}
            onChange={(e) => setPhotoUrl(e.target.value)}
          />
        </Box>
      </DialogContent>

      <DialogActions className={classes.botoes}>
        <Button onClick={onFechar} className={classes.botaoCancelar} variant="contained">
          Fechar
        </Button>

        <Button
          onClick={salvar}
          className={classes.botaoSalvar}
          variant="contained"
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
